import {createApi} from '@reduxjs/toolkit/query/react';

import {ITableReportProps} from 'components/table-report/table-report-types';
import {ERequestType, TRequestTableResponseWithPagination} from 'shared/types/requests';
import {axiosBaseQuery} from 'store/api/base-query';

import {CONTROL_RATIOS_API_PREFIX} from '../model/constants';
import {
    IControlRatioCalculationDto,
    IControlRatioCalculationTableParams,
    IControlRatioStatisticDto,
    IControlRatioStatisticTableParams,
} from '../model/types';

export const CustomControlRatiosCalculationApi = createApi({
    reducerPath: 'customControlRatiosCalculationApi',
    tagTypes: ['CustomControlRatiosCalculationApi'],
    baseQuery: axiosBaseQuery(),
    endpoints: builder => ({
        fetchControlRatioCalculationTable: builder.query<
          TRequestTableResponseWithPagination<IControlRatioCalculationDto>,
          IControlRatioCalculationTableParams
        >({
            query: params => ({
                url: CONTROL_RATIOS_API_PREFIX,
                method: ERequestType.GET,
                params,
            }),
        }),
        fetchControlRatioStatisticTable: builder.mutation<
          IControlRatioStatisticDto[],
          IControlRatioStatisticTableParams
        >({
            query: ({docId, ids}) => ({
                url: `${CONTROL_RATIOS_API_PREFIX}/statistics/${docId}`,
                method: ERequestType.POST,
                data: {ids},
            }),
        }),
        calculateControlRatios: builder.mutation<
          string,
          {childDocId: ITableReportProps['docId']}
        >({
            query: ({childDocId}) => ({
                url: `${CONTROL_RATIOS_API_PREFIX}/calculate/${childDocId}`,
                method: ERequestType.POST,
            }),
        }),
    }),
});

export const {
    useFetchControlRatioCalculationTableQuery,
    useFetchControlRatioStatisticTableMutation,
    useCalculateControlRatiosMutation,
} = CustomControlRatiosCalculationApi;
